import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

// theme components
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

// custom components
import ScaffoldBase from "components/CustomScaffold/ScaffoldBase";

// React-Redux reducers
import { connect } from "react-redux";

import {
  fetchReclami,
  fetchReclamo,
  deleteReclamo
} from "actions/reclami";

import { compose } from "redux";
import { withRouter } from "react-router";

class ReclamiCliente extends React.Component {

  state = {
    /*filtro: {
      Nome: { 'campo': 'Nome', 'valore': ''},
      Cognome: { 'campo': 'Cognome', 'valore': ''},
    }*/
  }

  componentDidMount() {
    const { loadReclami, utenteLoggato} = this.props
      
    if (utenteLoggato["Azienda"])
      loadReclami([ { 'campo': 'Proponente', 'operatore' : '=', 'valore': utenteLoggato['Azienda']._id } ]);
  }

  // funzione utilizzata per spostarsi nella pagina di inserimento nuovo reclamo
  aggiungiReclamo() {
    const { history } = this.props

    history.push('/dashboard/reclami/add')
  }

  // cancella il reclamo
  cancellaReclamo(id) {
    const { delReclamo } = this.props
    Promise.resolve()
    .then( () => delReclamo(id) )
    .then(() => {
      const { loadReclami, utenteLoggato } = this.props

      if (utenteLoggato["Azienda"])
        loadReclami([ { 'campo': 'Proponente', 'operatore' : '=', 'valore': utenteLoggato['Azienda']._id } ])
    })
  }

  apriModificaReclamo(id) {
    const { history } = this.props

    history.push('/dashboard/reclami/'+id+'/edit')
  }

  // applico il filtro
  /*handleFilterBy = (e) => {
    const proprieta = e.target.name
    const valore = e.target.value

    const { filtro } = this.state
    const { loadDipendenti, utenteLoggato } = this.props

    filtro[proprieta] = { 'campo': proprieta, 'valore': valore }

    this.setState({ filtro })

    let filtroLoad = [
      { 'campo': 'Azienda', 'valore': utenteLoggato['Azienda']._id}
    ]

    Object.keys(filtro).forEach( (k) => {
      filtroLoad.push(filtro[k])
    })

    loadDipendenti(filtroLoad)

  }*/

  render() {
    const { reclami, classes } = this.props;
    //const { filtro } = this.state
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Button onClick={() => this.aggiungiReclamo()} style={{background: /*"linear-gradient(60deg, #7d6960, #3e2a23)"*/"linear-gradient(60deg, #022f65, #004494)", color: "#ffffff"}} variant="contained"><AddIcon />
              Aggiungi nuovo reclamo
            </Button>
          </GridItem>
        </GridContainer>
        <ScaffoldBase title="Lista reclami" subtitle="Dettaglio reclami">
          { reclami && reclami.length > 0 &&
          <GridItem xs={12} sm={12} md={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Azione</TableCell>
                  <TableCell>Giorno</TableCell>
                  <TableCell>Oggetto</TableCell>
                  <TableCell>Descrizione</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                    reclami && reclami.map( (reclamo) => 
                      <TableRow key={reclamo._id}>
                        <TableCell>
                            <Tooltip
                              id="tooltip-top"
                              title="Modifica"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Edit"
                                className={classes.tableActionButton}
                              >
                                <Edit
                                  className={
                                    classes.tableActionButtonIcon + " " + classes.edit
                                  }
                                  onClick={() => this.apriModificaReclamo(reclamo._id)}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              id="tooltip-top-start"
                              title="Elimina"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Close"
                                className={classes.tableActionButton}
                              >
                                <Close
                                  className={
                                    classes.tableActionButtonIcon + " " + classes.close
                                  }
                                  onClick={() => this.cancellaReclamo(reclamo._id)}
                                />
                              </IconButton>
                            </Tooltip>
                        </TableCell>
                        <TableCell>{new Date(reclamo["Giorno"]).toLocaleDateString('it-IT', { month: '2-digit', day: '2-digit', year: 'numeric' })}</TableCell>
                        <TableCell>{reclamo["Oggetto"]}</TableCell>
                        <TableCell>{reclamo["Descrizione"]}</TableCell>
                      </TableRow>
                    ) 
                  }
              </TableBody>
            </Table>
          </GridItem>
          }

          { (!reclami || reclami.length <= 0) && 
            <GridItem>
              <p>Reclami non disponibili</p>
            </GridItem> 
          }
        </ScaffoldBase>
      </div>
    );
  }
}

ReclamiCliente.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapDispatchToProps( dispatch ) {
  return {
    loadReclami: (filtro) => dispatch(fetchReclami(filtro)),
    setReclamo: (id) => dispatch(fetchReclamo(id)),
    delReclamo: (id) => dispatch(deleteReclamo(id))
  }
}

function mapStateToProps({ reclami, authentication }) {
  return { 
    reclami: reclami.items,
    utenteLoggato: authentication.user
  };
}

export default compose(
  withStyles(dashboardStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(withRouter(ReclamiCliente));
